export default __webpack_public_path__ + "static/media/Background_00217.02644d17.png";